import axios from 'axios';
// https://api.truvey.in/api 
// Base configuration for axios
const apiClient = axios.create({
  //baseURL: process.env.REACT_APP_API_BASE_URL || 'https://api.truvey.in/api', // Replace with your API base URL
   //baseURL: process.env.REACT_APP_API_BASE_URL || 'https://localhost:44346/api', // Replace with your API base URL
  baseURL: process.env.REACT_APP_API_BASE_URL || 'https://api.xprssurvey.com/api', // Replace with your API base URL
  //baseURL: process.env.REACT_APP_API_BASE_URL || 'https://xprssurveyapi.demoo4s.com/api', // Replace with your API base URL
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add a request interceptor to include the JWT token in the headers
apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('token'); // Retrieve token from local storage
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

const SurveyRunService = {
  GetSurveyDetailsByResponder: async (ResponderUID) => {
    try {
      const response = await apiClient.post('/Survey/SurveyDetailsByResponder',
        { ResponderUID }
        , {
          headers: {
            'Content-Type': 'application/json'
          }
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching permission data:", error);
    }
  },
  StartSurvey: async (ResponderUID) => {
    try {
      const response = await apiClient.post('/Survey/StartSurvey',
        { ResponderUID }
        , {
          headers: {
            'Content-Type': 'application/json'
          }
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching permission data:", error);
    }
  },
  NextQuestion: async (UniqueKey, QuestionID, UserAnswer) => {
    try {
      const response = await apiClient.post('/Survey/NextQuestion',
        { UniqueKey, QuestionID, UserAnswer }
        , {
          headers: {
            'Content-Type': 'application/json'
          }
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching permission data:", error);
    }
  },
  FinishSurvey: async (UniqueKey, QuestionID, UserAnswer) => {
    try {
      const response = await apiClient.post('/Survey/FinishSurvey',
        { UniqueKey, QuestionID, UserAnswer }
        , {
          headers: {
            'Content-Type': 'application/json'
          }
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching permission data:", error);
    }
  },
  PreviousQuestion: async (UniqueKey, QuestionID, UserAnswer) => {
    try {
      const response = await apiClient.post('/Survey/PreviousQuestion',
        { UniqueKey, QuestionID, UserAnswer }
        , {
          headers: {
            'Content-Type': 'application/json'
          }
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching permission data:", error);
    }
  },
  GetSurveyDataOnSurveyID: async (SurveyUID) => {
    try {
      const response = await apiClient.post('/SurveyRun/SurveyDetailsForRun',
        { SurveyUID }
        , {
          headers: {
            'Content-Type': 'application/json'
          }
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching permission data:", error);
    }
  },
  StartSurveySingle: async (SurveyUID,ResponderUID) => {
    try {
      const response = await apiClient.post('/SurveyRun/StartSurveyRun',
        { SurveyUID,ResponderUID }
        , {
          headers: {
            'Content-Type': 'application/json'
          }
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching permission data:", error);
    }
  },
}

export default SurveyRunService;
